$(function () {
	if (!!$(".section-tabs").length) {
		// Configuration for debug logging
		const DEBUG_ENABLED = window.location.hostname === "localhost";
		
		const log = (message, ...args) => {
			if (DEBUG_ENABLED) {
				console.log(`[SectionTabs] ${message}`, ...args);
			}
		};
		
		const container = document.querySelector(".section-tabs");
		const navTabs = [...container.querySelectorAll("a.section-tabs__nav-link")]; 
		const inlineTabLinks = [...container.querySelectorAll('a[title="tab-nav-link"]')];
		//replace this with a[title=tab-nav-link] and instruct client to add that to link title
		const indicator = container.querySelector(".section-tabs__indicator");
		const contentArea = container.querySelector(".section-tabs__content");
		const isRMF = !!document.querySelector(".page--RM");
		const isORG = !!document.querySelector(".page--ORG");
		let url = new URL(window.location);
		let activeTab;
		let activeSection;
		const breakpoint = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--lg_dn")?.trim().split("px")[0]) || 991;
		let windowWidth = window.innerWidth;
		if (!!navTabs.length) {

			const getActiveTabFromHash = () => {
				// if redirected from other page with #hash in url, automatically select that tab/section
				// otherwise, select first tab/section
				let tab;
				if (!!url.hash && !!container.querySelector(`a.section-tabs__nav-link[href='${url.hash}']`)) {
					tab = container.querySelector(`a.section-tabs__nav-link[href='${url.hash}']`);
				} else if (!!url.hash) {
					// If the hash is not a tab, check if it is targeting an element within a tab
					// Find the tab that contains the target element and set it as active
					const targetElement = container.querySelector(url.hash);
					if (targetElement) {
						var section = targetElement.closest(".section-tabs__section");
						if (section) {
							let tabId = section.getAttribute("id");
							tab = container.querySelector(`a.section-tabs__nav-link[href='#${tabId}']`);
						}
					}
				} 

				return tab || navTabs[0];
			}
			activeTab = getActiveTabFromHash();

			const updateActive = skipClassUpdates => {
				windowWidth = window.innerWidth;
				// if only updating because of window resize, no need to trigger class update code
				if (!skipClassUpdates) {
					let start = contentArea.offsetHeight;
					contentArea.style.overflow = "hidden";
					container.querySelector("a.active")?.classList.remove("active");
					container.querySelector("div.active")?.classList.remove("active");
					activeTab.classList.add("active");
					activeSection = container.querySelector(activeTab.getAttribute("href"));
					activeSection.classList.add("active");
					let end = contentArea.offsetHeight;
					contentArea.animate([
						{height: start + "px"},
						{height: end + "px"}
					], {
						duration: 300,
						behavior: "smooth"
					});
					setTimeout(() => {
						contentArea.style.overflow = "";
					}, 300)
				}
				let topVal = "calc(100% - 2px)";
				let heightVal = "2";
				if (isRMF) {
					topVal = "calc(100% - 4px)";
					heightVal = "4px";
				} else if (isORG) {
					topVal = "calc(100% - 16px)";
					heightVal = "6px";
				}
				const activeItem = activeTab.closest(".section-tabs__nav-item");
				let leftOffset;
				if (isORG) {
					leftOffset = activeItem.offsetLeft + activeTab.offsetLeft;
				} else {
					leftOffset = activeTab.offsetLeft;
				}
				let width = windowWidth < breakpoint ? heightVal : activeTab.getBoundingClientRect().width + "px";
				let left = windowWidth < breakpoint ? "0" : leftOffset + "px";
				let height = windowWidth >= breakpoint ? heightVal : activeTab.offsetHeight + "px";
				let top = windowWidth >= breakpoint ? topVal : activeTab.offsetTop + "px";
				indicator.style.cssText = `
					width: ${width}; 
					height: ${height};
					top: ${top};
					left: ${left};
				`;
			}
			updateActive();

			// Below used to position page on active tab content if loaded with hash value in url
			const positionPage = () => {
				let hash = url.hash;
				if (!!hash && !!container.querySelector(`a[href='${hash}']`)) {
					// The target element is a tab, so scroll to the top of the page
					setTimeout(() => {
						window.scrollTo({
							top: 0,
							behavior: "instant"
						});
					}, 1);
				} else if (!!hash) {
					// The target element is not a tab, so scroll to the target element
					setTimeout(() => {
						// Scroll to the top of the target element with padding for the header
						const targetElement = container.querySelector(hash);
						const headerOffset = document.querySelector(".header")?.offsetHeight || 0;
						let targetScroll = window.scrollY + targetElement.getBoundingClientRect().top - headerOffset;
						window.scrollTo({
							top: targetScroll,
							behavior: "instant"
						});
					}, 1);
				}
			}
			positionPage();

			navTabs.forEach(tab => {
				tab.addEventListener("click", e => {
					e.preventDefault();
					activeTab = tab;
					const hash = tab.getAttribute("href");
					window.history.replaceState(null, "", url.origin + url.pathname + hash);
					updateActive();
					// Don't call positionPage here, if the user is clicking a tab, they don't need to scroll to it.
				});
			});

			inlineTabLinks.forEach(link => {
				link.addEventListener("click", e => {
					e.preventDefault();
					const hash = link.getAttribute("href");
					activeTab = Array.from(navTabs).find(nav => nav.getAttribute("href") === hash);
					window.history.replaceState(null, "", url.origin + url.pathname + hash);
					updateActive();
					positionPage();
				});
				link.removeAttribute("title");
			});
	
			window.addEventListener("resize", () => {
				let currentWidth = window.innerWidth;
				// if screen resize moves past breakpoint, update position of indicator
				if (currentWidth < breakpoint && windowWidth >= breakpoint
				|| currentWidth >= breakpoint && windowWidth < breakpoint) {
					updateActive(true);
				}
				windowWidth = currentWidth;
			});			

			// Handle hash change for back/forward navigation and also when a 
			// URL is directly entered for the same page but different hash.
			window.addEventListener("hashchange", (event) => {
				url = new URL(window.location);
				const newActiveTab = getActiveTabFromHash();
				if (newActiveTab !== activeTab) {
					activeTab = newActiveTab;
					updateActive();
					positionPage();
				}
			});

			// Code to hijack alchemer form submission to get back to Contact tab after submission
			const hasAlchScript = document.querySelector("script[src*=alchemer]") || false;
			
			const addHash = (event, bool, resolveFunc) => {
				log('addHash called with bool:', bool);
				if (!bool) {
					event.preventDefault();
					const tabId = activeSection.getAttribute("id");
					// Possible Improvement: store the current url as part of the key in localStorage
					// to avoid conflicts with other forms on other pages.
					log('Storing hash in localStorage:', `#${tabId}`);
					window.localStorage.setItem("contactFormTabHash", `#${tabId}`);
					bool = true;
					setTimeout(resolveFunc, 100);
				}
			}
			
			const addSubmitListener = async formEl => {
				log('Adding submit listener to form:', formEl);
				let submit = formEl.querySelector("input[type=submit], button[type=submit]");
				let submitted = false;
				if (submit) {
					log('Found submit button:', submit);
					submit.addEventListener("click", async e => {
						log('Submit button clicked, submitted state:', submitted);
						await new Promise(resolve => addHash(e, submitted, resolve));
						submitted = true;
						log('Triggering actual submit click');
						submit.click();
					});
				} else {
					log('No submit button found in form');
				}
			}			

			const setActiveTabFromStorage = () => {
				log('Checking localStorage for saved tab hash');
				let hash = window.localStorage.getItem("contactFormTabHash");
				if (!hash) {
					log('No hash found in localStorage');
					return;
				}

				log('Found hash in localStorage:', hash);
				let contactTabLink = document.querySelector(`a[href="${hash}"]`) || false;
				if (contactTabLink) {
					log('Found matching tab link, clicking:', contactTabLink);
					contactTabLink.click();
					log('Removing hash from localStorage');
					window.localStorage.removeItem("contactFormTabHash");
				} else {
					log('No matching tab link found for hash:', hash);
				}
			}			
			
			if (hasAlchScript) {
				log('Alchemer script detected, setting up form check interval');
				// Check for alchemer form to load every 500ms for 25 seconds
				let form = null;
				let i = 0;
				let formCheckInterval = setInterval(() => {
					if (i % 10 === 0) { // Log only every 10 attempts to reduce console spam
						log('Checking for Alchemer form, attempt:', i + 1, 'of 50');
					}
					if (form || i >= 50) {
						log('Form check complete -', form ? 'Form found' : 'Max attempts reached');
						clearInterval(formCheckInterval);
						formCheckInterval = null;
						return;
					} else if (!!document.querySelector("form[action*=alchemer]")) {
						form = document.querySelector("form[action*=alchemer]");
						log('Alchemer form found:', form);
						// Listen for form submissions in the event the user fills out the form and submits it.
						addSubmitListener(form);
						// Check if the form is was already submitted and if so, set the active tab to the appropriate tab.
						setActiveTabFromStorage();
					}
					i++;
				}, 500);
				log('Form check interval started, will check for up to 25 seconds');
			}
		}
	}
});
